import api from './api'; // Replace with the actual path to your API functions
import Vuex from 'vuex';

const store = new Vuex.Store({
    state: {
        cart: [],
        wrapper_selected: null,
        settings: {}
    },
    mutations: {
        autoAddToCart(state, cartItem) {
            const index = state.cart.findIndex(item => item.id === cartItem.id);
            if (index !== -1) {
                state.cart.splice(index, 1, cartItem);
            } else {
                state.cart.push(cartItem);
            }
        },
        addToCart(state, cartItem) {
            const index = state.cart.findIndex(item => item.id === cartItem.id);
            if (index !== -1) {
                state.cart.splice(index, 1, cartItem);
            } else {
                state.cart.push(cartItem);
            }
        },
        removeFromCart(state, cartItemId) {
            state.cart = state.cart.filter(item => item.id !== cartItemId);
        },
        setWrapperSelected(state, wrapper) {
            state.wrapper_selected = wrapper;
        },
        removeWrapperSelected(state) {
            state.wrapper_selected = null;
        },
        setSettings(state, settings) {
            state.settings = settings;
        },
        setCoupon(state, coupon) {
            state.coupon = coupon;
        }
    },
    actions: {
        async autoAddToCart({ commit }, cartItem) {
            commit('autoAddToCart', cartItem);
        },
        async addToCart({ commit }, payload) {
            const response = await api.addToCart({
                'quantity': payload.quantity,
                'product_id': payload.product.id,
                'selected_attributes': JSON.stringify(payload.selected_attributes),
                'selected_price_id': payload.selected_price_id,
            });

            if (response && response.status) {
                commit('addToCart', {
                    ...payload,
                    id: response.data.id,
                    quantity: response.data?.quantity,
                    selected_attributes: response.data?.selected_attributes,
                    selected_price: response.data?.selected_price
                });
            }
            return response;
        },
        async removeFromCart({ commit }, cartItemId) {
            await api.removeFromCart({ id: cartItemId });
            commit('removeFromCart', cartItemId);
        },
        setWrapperSelected({ commit }, wrapper) {
            commit('setWrapperSelected', wrapper);
        },
        removeWrapperSelected({ commit }) {
            commit('removeWrapperSelected');
        },
        setMainSettings({ commit }, settings) {
            commit('setSettings', settings);
        },
        async applyCoupon({ commit }, couponCode) {
            const response = await api.checkCoupon(couponCode);
            console.log(response);
            if (response && response.status) {
                commit('setCoupon', response.data);
            }
            return response;
        }
    },
    getters: {
        cartItems: state => {
            return state.cart;
        },
        getSelectedAttributeValue: (state) => (attributeId, cartItem) => {
            if (!cartItem || !cartItem.selected_attributes || !cartItem.product?.attributes) {
                return '';
            }
            const attribute = cartItem.product?.attributes[attributeId];
            const selectedAttributeId = cartItem.selected_attributes[attributeId];
            const selectedAttribute = attribute?.items?.find(item => item.id === selectedAttributeId);

            return selectedAttribute ? selectedAttribute.value : '';
        },
        subtotal: (state, getters) => {
            const cartSubtotal = state.cart.reduce((subtotal, cartItem) => {
                const price = cartItem.selected_price?.price || cartItem.product.price;
                return subtotal + (cartItem.quantity || 0) * price;
            }, 0);

            const wrapperSubtotal = state.wrapper_selected ? state.wrapper_selected.price : 0;
            return parseFloat(cartSubtotal + wrapperSubtotal).toFixed(2);
        },
        cartSubtotalDiscountable: (state, getters) => { // المنتجات التي يمكن تطبيق الخصم عليها حسب إعدادات المنتج
            const cartSubtotalDiscountable = state.cart.reduce((subtotal, cartItem) => {
                if(cartItem.product?.discountable === false){
                    return subtotal;
                }
                const price = cartItem.selected_price?.price || cartItem.product.price;
                return subtotal + (cartItem.quantity || 0) * price;
            }, 0);

            const wrapperSubtotal = state.wrapper_selected ? state.wrapper_selected.price : 0;
            // return parseFloat(cartSubtotalDiscountable).toFixed(2);
            return parseFloat(cartSubtotalDiscountable + wrapperSubtotal).toFixed(2);
        },
        discount: (state, getters) => {
            const percentage   = ( state.coupon ? state.coupon.discount : 0 ) ;
            return parseFloat(getters.cartSubtotalDiscountable) / 100 * percentage;
        },
        isFreeShipping: state => {
            return state.coupon ? state.coupon.free_shipping : false;
        },
        shippingCost: (state, getters) => {
            if (getters.isFreeShipping){
                return  0;
            }
            return state.settings?.shipping_cost ?? 0;
        },
        tax: (state, getters) => {


            return parseFloat(
                (parseFloat( parseFloat(getters.subtotal) - getters.discount + 0 ) + parseFloat(getters.shippingCost ) ) * 0.15 // الضريبة المضافة كنسبة من الإجمالي
            ).toFixed(2);


            // return parseFloat(
            //     (parseFloat(getters.subtotal) - getters.discount + 0) * 0.15
            // ).toFixed(2);
        },
        // tax: (state, getters) => {
        //     console.log(state);
        //
        //     return parseFloat(
        //         (parseFloat(getters.subtotal) + parseFloat(state.settings?.shipping_cost ?? 0)) * 0.15
        //     ).toFixed(2);
        // },
        total: (state, getters) => {
            return parseFloat(
                (parseFloat(getters.subtotal) -
                getters.discount) +
                parseFloat(getters.tax) +
                parseFloat(getters.shippingCost )
            ).toFixed(2);
        },
        // total: (state, getters) => {
        //     return parseFloat(
        //         parseFloat(getters.subtotal) +
        //         parseFloat(getters.tax) +
        //         parseFloat(state.settings?.shipping_cost ?? 0)
        //     ).toFixed(2);
        // }
    }
});

export default store;
